module.exports = __webpack_public_path__ + "static/media/DUETS W MY WHANAU.33a3981d.jpg";